module.exports = __webpack_public_path__ + "static/media/5.1 Eisvogel Vorzustand.35785c34.jpg";